/** Instant tooltips. Native `title` is delayed (~1s) and often never shows on overlay UI. */
export function installTips(root: HTMLElement = document.body): void {
  let tip = document.getElementById("ignis-tip");
  if (!tip) {
    tip = document.createElement("div");
    tip.id = "ignis-tip";
    tip.setAttribute("role", "tooltip");
    root.appendChild(tip);
  }
  let active: HTMLElement | null = null;

  const hide = () => {
    active = null;
    tip!.classList.remove("on");
  };

  const show = (el: HTMLElement) => {
    const text = el.dataset.tip?.trim();
    if (!text) return;
    active = el;
    tip!.textContent = text;
    tip!.classList.add("on");
    place(tip!, el);
  };

  root.addEventListener("pointerover", (ev) => {
    const raw = ev.target as HTMLElement | null;
    // Chart points have their own hover — do not also raise the global tip.
    if (raw?.closest?.(".frp-chart-wrap")) {
      hide();
      return;
    }
    const el = raw?.closest?.("[data-tip]") as HTMLElement | null;
    if (el === active) return;
    if (!el) {
      hide();
      return;
    }
    show(el);
  });
  root.addEventListener("pointerdown", hide);
  root.addEventListener(
    "scroll",
    () => {
      if (active) hide();
    },
    true,
  );
}

function place(tip: HTMLElement, el: HTMLElement): void {
  const r = el.getBoundingClientRect();
  const pad = 8;
  // Match #ignis-tip max-width so 14px copy does not wrap too early.
  const tw = Math.min(280, window.innerWidth - 16);
  tip.style.width = "max-content";
  tip.style.maxWidth = `${tw}px`;
  const th = tip.offsetHeight;
  const left = Math.min(Math.max(8, r.left), window.innerWidth - tw - 8);
  const above = r.top - th - pad;
  const top = above > 8 ? above : r.bottom + pad;
  tip.style.left = `${left}px`;
  tip.style.top = `${top}px`;
}
